import { render, staticRenderFns } from "./area-header.vue?vue&type=template&id=22592a42&scoped=true"
import script from "./area-header.vue?vue&type=script&lang=js"
export * from "./area-header.vue?vue&type=script&lang=js"
import style0 from "./area-header.vue?vue&type=style&index=0&id=22592a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22592a42",
  null
  
)

export default component.exports